import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundIfAboveOne',
  standalone: false,
})
export class RoundIfAboveOnePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  transform(value: number, digitsInfo?: string): number | string {
    if (value > 1 || value < -1) {
      value = Math.round(value);
    }

    return formatNumber(value, this.locale, digitsInfo);
  }
}
